export const DEFAULT_BRANDING = {
    productName: 'PayrollNoot',
    primaryColor: '#E7730A',
    darkColor: '#CC5500',
    logoUrl: null,
    loginLogoUrl: null,
    faviconUrl: null,
};

const useBranding = () => {
    try {
        const stored = JSON.parse(localStorage.getItem('branding') || 'null');
        if (stored && typeof stored === 'object') {
            return { ...DEFAULT_BRANDING, ...stored };
        }
    } catch { /* ignore parse errors */ }
    return { ...DEFAULT_BRANDING };
};

export default useBranding;
